import React from "react";
import { Instagram, Facebook, Twitter, Linkedin, Mail, Phone, ArrowUpRight } from "lucide-react";

const navCols = [
  {
    title: "Studio",
    links: [
      { label: "Features", href: "#features" },
      { label: "Work", href: "#work" },
      { label: "Values", href: "#values" },
      { label: "FAQ", href: "#faq" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", href: "/privacy-policy" },
      { label: "Terms of Service", href: "/terms-of-service" },
    ],
  },
];

function Footer() {
  return (
    <footer className="relative bg-levi-bg border-t border-levi-border">
      <div className="container-xl pt-20 pb-10">
        {/* Top - big CTA */}
        <div className="grid md:grid-cols-12 gap-10 pb-16 border-b border-levi-border">
          <div className="md:col-span-7">
            <h3 className="display-lg text-levi-text">
              Built with <span className="text-levi-primary">discipline.</span>
              <br />
              Shipped with care.
            </h3>
          </div>
          <div className="md:col-span-5 flex md:justify-end items-end">
            <a
              href="mailto:tphuc.work@gmail.com"
              className="group inline-flex items-center gap-3 text-levi-text hover:text-levi-primary transition-colors"
            >
              <span className="font-display text-2xl md:text-3xl tracking-widest uppercase">
                tphuc.work@gmail.com
              </span>
              <ArrowUpRight size={22} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
            </a>
          </div>
        </div>

        {/* Middle - columns */}
        <div className="grid md:grid-cols-12 gap-10 py-16">
          <div className="md:col-span-5">
            <a href="/" className="flex items-center gap-3 mb-6">
              <img
                src="/assets/levi-logo.jpg"
                alt="Phuc Pham"
                className="h-12 w-12 rounded-full object-cover ring-2 ring-levi-primary/70"
              />
              <div className="flex flex-col leading-none">
                <span className="font-display text-2xl tracking-widest text-levi-text whitespace-nowrap">Phuc Pham</span>
                <span className="font-mono text-[10px] tracking-ultra uppercase text-levi-muted">Studio</span>
              </div>
            </a>
            <p className="text-levi-muted max-w-sm leading-relaxed">
              A small, stubborn studio shipping apps that users actually keep open.
              Based in Vietnam, working globally.
            </p>
            <div className="mt-8 flex gap-3">
              {[Instagram, Facebook, Twitter, Linkedin].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label={Icon.name}
                  className="p-3 border border-levi-border text-levi-muted hover:border-levi-primary hover:text-levi-primary transition-colors"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {navCols.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <div className="eyebrow mb-6">{col.title}</div>
              <ul className="space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="text-levi-muted hover:text-levi-text transition-colors"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-3">
            <div className="eyebrow mb-6">Direct</div>
            <ul className="space-y-4">
              <li>
                <a href="mailto:tphuc.work@gmail.com" className="flex items-center gap-3 text-levi-muted hover:text-levi-text transition-colors">
                  <Mail size={14} /> tphuc.work@gmail.com
                </a>
              </li>
              <li>
                <a href="tel:+84367183161" className="flex items-center gap-3 text-levi-muted hover:text-levi-text transition-colors">
                  <Phone size={14} /> +84 367 183 161
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8 border-t border-levi-border">
          <p className="text-sm text-levi-subtle font-mono">
            © {new Date().getFullYear()} Phuc Pham · All rights reserved.
          </p>
          <p className="text-sm text-levi-subtle font-mono">
            Crafted in Vietnam · v1.0
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
